// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useSubscription } from 'Data/Api'
import useDataTransform from './useDataTransform'
import useDataConfiguration from './useDataConfiguration'
import useDataOnChange from './useDataOnChange'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function SendForSignatureActionData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, error }, reExecuteQuery] = useSubscription({ query, ...configuration })
  let data = useDataTransform(props, rdata?.documents_signature_requests)
  let onChange = useDataOnChange(props, data)

      useSetFlowToBasedOnData({
        data,
        fetching: typeof data === 'undefined',
        error,
        pause: configuration.pause,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="signature"
      value={data}
      viewPath={props.viewPath}
      onChange={onChange}
    >
      <View {...props} />
    </DataProvider>
  )
}